import styles from './FilterBar.scss';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { locationShape, routerShape } from 'react-router';
import lodash from 'lodash';
import { isIE11 } from 'common/util/mobile';

import Dropdown from 'components/common/Dropdown/Dropdown';

export class FilterBar extends Component {
    constructor() {
        super();
        this.state = {
            focused:false
        };
    }

    createFilterEventHandler(queryStringParameter, value){
        function handler(e) {
            const { router, location, debounceQueryMS } = this.props;
            const replace = lodash.debounce(router.replace, debounceQueryMS || 0);
            value = value || e.target.value;
            const newLocation = lodash.cloneDeep(location);
            newLocation.query = {
                ...newLocation.query,
                offset: 0,
                [queryStringParameter]: value
            };
            replace(newLocation);
        }
        return handler.bind(this);
    }

    getHeaders() {
        const {
            location: {
                query
            },
            sortOptions={},
            sortOrderOptions={}
        } = this.props;

        const sortGqlName = query[lodash.get(sortOptions, 'queryStringParameter', 'sort')];
        const sortOrderGqlName = query[lodash.get(sortOrderOptions, 'queryStringParameter', 'order')];

        const sortLabel = lodash.get(sortOptions, 'label', '');
        const activeSort = lodash.find(sortOptions.selection, { gqlName: sortGqlName }) || lodash.head(sortOptions.selection);
        const sortOrderLabel = lodash.get(sortOrderOptions, 'label', '');
        const activeSortOrder = lodash.find(sortOrderOptions.selection, { gqlName: sortOrderGqlName }) || lodash.head(sortOrderOptions.selection);

        return {
            sortLabel,
            activeSortText: activeSort ? `${activeSort.displayName}` : '',
            sortOrderLabel,
            activeSortOrderText: activeSortOrder ? `${activeSortOrder.displayName}` : '',
        };
    }

    clearQueryOnClose(){
        this.refs.queryText.value = '';
        return this.clearQuery();
    }

    clearQueryOnEscape(e){
        if (e.which !== 27) {
            return;
        }
        this.refs.queryText.value = '';
        return this.clearQuery();
    }

    clearQuery() {
        const { router, location } = this.props;
        const newLocation = lodash.cloneDeep(location);
        newLocation.query = {
            ...newLocation.query,
            offset: 0,
            ['q']: ''
        };
        router.replace(newLocation);
    }

    blurAndFocus() {
        // Hack to fix issue with IE11, where Input fields inside draggable div require double click to focus
        if(isIE11()) {
            const queryText = this.refs.queryText;
            queryText.blur();
            queryText.focus();
        }
    }

    toggleState(stateProprty) {
        const { state } = this;
        this.setState({
            [stateProprty]:!state[stateProprty]
        });
    }

    getFilterControlsStyling() {
        const { focused } = this.state;
        const focusStyle = focused ? styles.listControls__focused : '';
        return `${styles.listControls__left} ${focusStyle}`;
    }

    render() {
        const {
            location: {
                query: {
                    q
                }
            },
            sortOptions={},
            sortOrderOptions={},
        } = this.props;

        const sortQueryStringParameter = sortOptions.queryStringParameter || 'sort';
        const sortOrderQueryStringParameter = sortOrderOptions.queryStringParameter || 'order';

        const sorts = lodash.map(sortOptions.selection, (so, i) => {
            return {
                label: so.displayName,
                handler: this.createFilterEventHandler(sortQueryStringParameter, so.gqlName)
            };
        });

        const sortOrders = lodash.map(sortOrderOptions.selection, (so, i) => {
            return {
                label: so.displayName,
                handler: this.createFilterEventHandler(sortOrderQueryStringParameter, so.gqlName)
            };
        });

        const { sortLabel, activeSortText, sortOrderLabel, activeSortOrderText } = this.getHeaders();

        return (
            <div className={styles.listControls} data-cy="FilterBar">
                <div className={this.getFilterControlsStyling()}>
                    <div className={styles.filterBar}>
                        <i className={styles.filterBar__searchIcon}>search</i>
                        <input className={styles.filterBar__inputText}
                            type='text'
                            ref='queryText'
                            placeholder={this.props.placeholder}
                            value={q || ''} onChange={this.createFilterEventHandler('q')}
                            onKeyUp={this.clearQueryOnEscape.bind(this)}
                            onMouseUp={this.blurAndFocus.bind(this)}
                            onFocus={() => this.toggleState('focused')}
                            onBlur={() => this.toggleState('focused')}
                            data-cy="FilterBar-text"
                        />
                        {   q &&
                            [<span key={0} className={styles.filterBar__closeCaption} >'Esc' to clear, or</span>,
                                <button key={1} className={styles.filterBar__closeIcon}
                                    onClick={this.clearQueryOnClose.bind(this)}
                                    data-cy="FilterBar-clearQueryOnClose">close</button>]
                        }
                    </div>
                </div>
                <div className={styles.listControls__right} data-cy="FilterBar-DropdownControlMenu">
                    <DropdownControlMenu activeText={activeSortText} label={sortLabel} options={sorts} />
                    <DropdownControlMenu activeText={activeSortOrderText} label={sortOrderLabel} options={sortOrders} />
                </div>
            </div>
        );
    }
}

const DropdownControlMenu = ({ activeText, options, label }) => {    
    if (lodash.isEmpty(options)) {
        return null;
    }

    return (
        <div className={styles.control} data-cy="FilterBar-DropdownControlMenus">
            <Dropdown activeText={activeText} label={label} options={options}/>
        </div>
    );
};

const optionShape = {
    displayName: PropTypes.string.isRequired,
    gqlName: PropTypes.string
};

FilterBar.propTypes = {
    router: routerShape.isRequired,
    location: locationShape.isRequired,
    placeholder: PropTypes.string,
    sortOptions: PropTypes.shape({
        label: PropTypes.string,
        options:PropTypes.arrayOf(
            PropTypes.shape(optionShape)
        )
    }),
    sortOrderOptions: PropTypes.shape({
        label: PropTypes.string,
        options:PropTypes.arrayOf(
            PropTypes.shape(optionShape)
        )
    }),
};

export default FilterBar;
